import React, { useEffect } from 'react'
import AuthLayout from '../layouts/AuthLayout'
import { AppBar, Box, IconButton, Typography,Input,  Backdrop} from '@mui/material'
import SearchIcon from "@mui/icons-material/Search";
import CustomButton from '../../components/CustomButton';
import { useState } from 'react';
import CustomSortOptions from '../events/components/CustomSortOptions';
import { timeStampToString } from '../../utils/commonServices';
import { useDispatch, useSelector } from 'react-redux';
import useSort from '../events/hooks/useSort';
import { useNavigate } from 'react-router';
import Header from '../userfiles/components/Header';
import CustomAutocomplete from '../eventcreation/components/CustomAutoComplete';
import { BRANDBOX_OPTIONS } from '../../constants/staticData';
import BrandboxOptions from './components/BrandboxOptions';
import { getNamesFromIds } from '../../commonactions/actions';
import { getErrorMsg } from '../../utils/validator';
import { createAsset, getAllAssets, getAssetOptionsList } from './actions';
import CompanyNamePopup from './components/CompanyNamePopup';
import { setAssetState } from '../../redux/assetSlice';
import UploadFilesPopup from './components/UploadFilesPopup';
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';


 const UserBrandbox = () => {

    const [selectedSortbyValue, setSelectedSortbyValue] = useState(null);
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const assetReducer = useSelector((state) => state.assetReducer);
    const [searchTerm, setSearchTerm] = useState('');
    const dispatch = useDispatch()
    const navigate = useNavigate()
    
    
    const [assets, setAssets] = useState(assetReducer?.selected_asset_files)
    const [searchedArray, setSearchedArray] = useState(assets)
    const [sortedFiles] = useSort(searchedArray, selectedSortbyValue)
    const [selectedBrandboxOption, setSelectedBrandboxOption] = useState({option_id: ''})
    const [brandboxOptionValidationFlag, setBrandBoxOptionValidationFlag] = useState(false)
    const [acceptType, setAcceptType] = useState('')
    const [expanded, setExpanded] = useState('');
    const [errorText, setErrorText] = useState('')





      const handleSearch = (e) => {
        const searchedInput = e.target.value.toLowerCase();
        setSearchTerm(searchedInput);

        const updatedFiles = [...assets];
   
        const results = updatedFiles?.filter(item =>
          item?.filename?.toLowerCase().includes(searchedInput) ||
          item?.event_name?.toLowerCase().includes(searchedInput)||
          item?.created_by?.toLowerCase().includes(searchedInput)||
          timeStampToString(item?.created_at)?.toLowerCase().includes(searchedInput)
        );
        setSearchedArray(results);
      };


 
 

  
    //  useEffect(()=>{
       
    //  },[selectedBrandboxOption.option_id])
     

     


    // useEffect(()=>{
    //   if( commonReducer?.company_name === null || commonReducer?.company_name === ''){    
    //     dispatch(setAssetState({brand_name_popup: true}))
    //     // getAllAssets(dispatch, navigate)
    //   }else{
    //     getAllAssets(dispatch, navigate)  
    //   }
    // },[commonReducer?.company_name])

  useEffect(()=>{
      setAssets(assetReducer?.selected_asset_files)
      setSearchedArray(assetReducer?.selected_asset_files)
  },[assetReducer?.selected_asset_files])

    

  return (
    <AuthLayout sx={{ padding: '2.1% 3.4% 2.1% 3.4%'}}>
        <Header/>
        <Box px={3} pr={6} className='flex col' mt={4} sx={{minWidth:'800px'}}>
              <Box sx={{display:'flex', justifyContent:'start', alignItems:'center', color:'black', mb:2, cursor:'pointer' }} gap={1}>
                    {/* <IconButton  onClick={()=>{navigate(-1)}}> */}
                      <KeyboardBackspaceOutlinedIcon onClick={()=>{navigate(-1)}} sx={{color:'black',}}/>
                    {/* </IconButton> */}
                    <Typography sx={{fontFamily: 'Rubik', fontSize:{xs:'10px',sm:'11px',md:'12px',lg:'14px',xl:'20px'}}}>Back</Typography>
                  </Box>
            <Box className='flex j-between' mb={3}>
                <Box className='flex a-center' gap={4}>
                  <Box>
                    <Typography sx={{color:'#000000', fontFamily:'Rubik', fontWeight:600, fontSize:{xs:'16px',md:'18px',lg:'20px',xl:'30px'}}}>Brandbox</Typography>
                    <Typography sx={{color:'#000000', fontFamily:'Rubik',  fontSize:{xs:'11px',md:'12px',lg:'13px',xl:'20px'}}}>Brand guidelines, color palette, and branded assets: find all your branded assets here!</Typography>
                  </Box>
                    {/* <Box id="search" >
                        <Input
                        value={searchTerm}
                        onChange={handleSearch}
                        inputProps={{ maxLength: 100 }}
                        sx={{
                          //  minWidth: '160px',
                            borderBottom: 2,
                            borderColor: "#333333",
                            input: {
                                fontSize: { xs: '12px', md: '13px', lg: '14px', xl: '20px' },
                                fontWeight: 400,
                                color: "#000000",
                            },
                        }}
                        placeholder="Search"
                        startAdornment={
                            <IconButton sx={{paddingBottom:1, fontSize: {xs:'12px',md:'14px',lg:'17px',xl:'24px'}, '& .MuiSvgIcon-root':{fontSize:{xs:'12px',md:'14px',lg:'17px',xl:'24px'}}, paddingRight:2}} >
                                <SearchIcon style={{ color: "#000000" }} />
                            </IconButton>
                        }
                        />
                    </Box> */}
                </Box>
                <Box className='flex a-center' gap={2}>   
                        {/* <Box>

                        <CustomButton 
                            btnText='Upload' 
                            onClick={()=>dispatch(setAssetState({upload_files_popup:true}))} 
                            type='button'
                            color='secondary'
                            variant='contained'
                            style={{
                                borderRadius: '5px',
                                border: "none",          
                                textTransform:'none',
                    
                                }}
                            sx={{fontSize:{xs:'10px',sm:'10px',md:'11px',lg:'12px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'18px',md:'20px',lg:'22px',xl:"36px"}, width:'6.1rem', fontFamily:'Rubik', marginBottom:{xs:'8px',md:'10px',lg:'11px',xl:'12px'},}}
                            />
                         
                        </Box> */}
                </Box>
            </Box>
            {/* {(allMediaFilesLoading == true) && <Typography variant='h3'>Loading...</Typography>} */}
            <BrandboxOptions
                files={sortedFiles}
                selectedBrandboxOption={selectedBrandboxOption.option_id}
                expanded={expanded}
                setExpanded={setExpanded}
            />
     
        </Box>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 100 }}
        //   open={createZippedMediaStatus == 'loading' }
        >
          <Typography>Please wait while we prepare your files for download...</Typography>
        </Backdrop>

       { assetReducer.upload_files_popup && <UploadFilesPopup/>}
    </AuthLayout>
  )
}

export default UserBrandbox